<div class="unpublish-warning">
    <p class="unpublish-warning__title">
        <i class="icon icon-alert-triangle"></i>
        {{ 'organize.unpublish-warning.title' | translate }}
    </p>

    <p class="unpublish-warning__text">{{ consequenceKey | translate }}</p>

    <p class="unpublish-warning__text" *ngIf="loading">{{ 'organize.unpublish-warning.loading' | translate }}</p>

    <ul class="unpublish-warning__lines" *ngIf="!loading && !failed && lines?.length">
        <li *ngFor="let line of lines">
            {{ line.labelKey | translate }} <strong>{{ line.value }}</strong>
        </li>
    </ul>

    <p class="unpublish-warning__text" *ngIf="!loading && failed">{{ 'organize.unpublish-warning.count-unavailable' | translate }}</p>

    <label class="unpublish-warning__confirm">
        {{ 'organize.unpublish-warning.type-to-confirm' | translate }} <strong>{{ confirmWord }}</strong>
        <input type="text" autocomplete="off" [ngModel]="typed" (ngModelChange)="onTyped($event)" [placeholder]="confirmWord">
    </label>
</div>
